import { render, staticRenderFns } from "./AccommodationCreate.vue?vue&type=template&id=bff89470&"
import script from "./AccommodationCreate.vue?vue&type=script&lang=js&"
export * from "./AccommodationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports